import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import NavMenu from './NavMenu';
import styled from 'styled-components';

const BreadCrumbWrapper = styled.div`
  background-color: #dcdcdc;
  text-align: right;
  pending-right: 0.938em;
  padding-top: 0.188em;
  padding-bottom: 0.438em;
  padding-right: 0.25em;
`;

const StyledBreadCrumb = styled.span`
  font-size: 14px;
  cursor: default;

  b {
    display: inline-block;
    margin-left: 0.417em;
    margin-right: 0.417em;
    font-size: 12px;
    font-weight: normal;
  }
`;

export const renderBreadCrumb = crumbs => (
  <BreadCrumbWrapper>
    {
      crumbs.map((crumb, i) => {
        // disable link to current page
        const isLink = (i !== crumbs.length - 1);
        return (
          <StyledBreadCrumb key={i}>
            {isLink && <Link to={crumb.href || '#'}>{crumb.title}</Link>}
            {isLink && <b>&gt;</b>}
            {!isLink && crumb.title}
          </StyledBreadCrumb>
        );
      })
    }
  </BreadCrumbWrapper>
);

const BreadCrumb = props => {
  const { location, renderFunction } = props;
  return (
    <NavMenu
      location={location}
      isBreadCrumb={true}
      renderBreadCrumb={renderFunction || renderBreadCrumb}
    />
  );
};

BreadCrumb.propTypes = {
  renderFunction: PropTypes.func,
  location: PropTypes.object.isRequired,
  styles: PropTypes.object
};

export default BreadCrumb;
